import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import SearchIcon from "@material-ui/icons/Search";
import { observer } from "mobx-react";

const Toolbar = observer(({ classes, weeks, selectProps, search }) => {
  return (
    <Grid
      container
      spacing={0}
      className={classes.toolBar}
      justify="center"
      alignItems="center"
    >
      <Grid item md={1} sm={12} xs={12}>
        <Typography variant="Subheading" align="left">
          Weeks back:
        </Typography>
      </Grid>

      <Grid item md={4} sm={12} xs={12}>
        <TextField
          {...selectProps(
            "weeks-back",
            "weeks",
            "Please select how many weeks back"
          )}
        >
          {weeks.map((weekNumber) => {
            return (
              <MenuItem
                {...{ key: `week-${weekNumber}`, value: weekNumber + 1 }}
              >
                {weekNumber + 1} week
                {weekNumber === 0 ? "" : "s"}
              </MenuItem>
            );
          })}
        </TextField>
      </Grid>

      <Grid item md={1} sm={12} xs={12}>
        <Typography variant="Subheading" align="left">
          Sort By:
        </Typography>
      </Grid>

      <Grid item md={4} sm={12} xs={12}>
        <TextField
          {...selectProps("sort-by", "sort", "Please select the sort criteria")}
        >
          {["Agent", "Date"].map((sortType, i) => {
            return (
              <MenuItem {...{ key: sortType, value: i }}>{sortType}</MenuItem>
            );
          })}
        </TextField>
      </Grid>

      <Grid item md={2} sm={12} xs={12}>
        <Button
          {...{
            variant: "raised",
            color: "primary",
            className: classes.button,
            fullWidth: true,
            onClick: search,
          }}
        >
          <SearchIcon className={classes.leftIcon} />
          SEARCH
        </Button>
      </Grid>
    </Grid>
  );
});

Toolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  weeks: PropTypes.arrayOf(PropTypes.number),
  search: PropTypes.func.isRequired,
  selectProps: PropTypes.func.isRequired,
};

export default Toolbar;
